const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMofCor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1696 622",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-334.013,-334.464)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,275.596,182.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-58.137L0,9.692L-16.612,9.692L-16.612,-67.829L12.459,-67.829L27.687,-8.303L41.528,-67.829L71.984,-67.829L71.984,9.692L55.373,9.692L55.373,-58.137L35.991,9.692L19.381,9.692L0,-58.137Z",
    style: {
      fill: "rgb(45,60,90)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,397.913,175.796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-44.299L-16.611,-44.299C-22.147,-44.299 -24.917,-40.608 -24.917,-33.225L-24.917,-11.076C-24.917,-3.693 -22.147,-0.003 -16.611,-0.003L0,-0.003C5.537,-0.003 8.308,-3.693 8.308,-11.076L8.308,-33.225C8.308,-40.608 5.537,-44.299 0,-44.299M-2.769,-60.91C15.69,-60.91 24.918,-50.759 24.918,-30.455L24.918,-13.844C24.918,6.459 15.69,16.611 -2.769,16.611L-13.843,16.611C-32.299,16.611 -41.527,6.459 -41.527,-13.844L-41.527,-30.455C-41.527,-50.759 -32.299,-60.91 -13.843,-60.91L-2.769,-60.91Z",
    style: {
      fill: "rgb(45,60,90)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.249,145.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.611L0,47.066L-16.61,47.066L-16.61,-30.455L38.762,-30.455L38.762,-13.844L0,-13.844L0,0L33.225,0L33.225,16.611L0,16.611Z",
    style: {
      fill: "rgb(45,60,90)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,200.839,194.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-97.157C-9.972,-106.681 -23.438,-112.398 -37.496,-113.786C-51.454,-115.161 -65.521,-113.036 -80.719,-103.081C-83.023,-101.634 -90.722,-95.498 -93.453,-92.136C-94.497,-90.744 -98.335,-86.236 -100.023,-83.429C-101.707,-80.625 -103.036,-78.181 -103.036,-78.181C-103.036,-78.181 -85.843,-107.644 -45.356,-100.381C-13.186,-94.829 8.668,-63.515 -0.148,-30.851C-6.162,-11.233 -24.497,3.043 -46.197,3.043C-63.695,3.043 -80.444,-5.467 -87.359,-20.151C-90.219,-26.22 -90.805,-30.28 -90.987,-36.458C-91.05,-38.676 -90.677,-39.974 -90.775,-40.279C-90.869,-40.589 -91.641,-37.565 -91.917,-35.124C-92.011,-34.169 -92.07,-33.584 -92.153,-32.402C-92.198,-31.792 -92.228,-31.309 -92.291,-30.248C-92.37,-28.809 -92.208,-26.418 -91.991,-24.448C-89.973,-10.11 -78.657,17.281 -44.371,18.004C-12.26,18.004 10.656,-4.883 17.414,-24.33C20.917,-33.179 21.854,-42.017 21.859,-49.269C21.002,-69.285 14.077,-84.665 0,-97.157",
    style: {
      fill: "rgb(60,144,173)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,102.022,115.288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,97.155C9.966,106.679 23.437,112.393 37.49,113.781C51.454,115.16 65.52,113.035 80.72,103.079C83.018,101.632 90.716,95.497 93.447,92.136C94.496,90.743 98.335,86.234 100.018,83.427C101.707,80.624 103.035,78.178 103.035,78.178C103.035,78.178 85.843,107.638 45.355,100.379C13.186,94.829 -8.668,63.515 0.147,30.849C6.157,11.231 24.496,-3.045 46.196,-3.045C63.694,-3.045 80.443,5.465 87.359,20.149C90.219,26.218 90.804,30.279 90.981,36.456C91.046,38.674 90.676,39.973 90.77,40.278C90.869,40.589 91.637,37.564 91.912,35.122C92.01,34.167 92.064,33.581 92.148,32.401C92.192,31.791 92.227,31.308 92.291,30.246C92.37,28.807 92.207,26.415 91.985,24.447C89.973,10.109 78.657,-17.282 44.367,-18.005C12.256,-18.005 -10.662,4.881 -17.415,24.329C-20.919,33.177 -21.854,42.014 -21.859,49.267C-21.007,69.282 -14.077,84.664 0,97.155",
    style: {
      fill: "rgb(60,144,173)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,151.431,118.011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-35.864,-35.864C-55.671,-35.864 -71.728,-19.803 -71.728,0.002C-71.728,19.808 -55.671,35.864 -35.864,35.864C-16.058,35.864 0,19.808 0,0.002C0,-19.803 -16.058,-35.864 -35.864,-35.864",
    style: {
      fill: "rgb(44,57,85)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,258.936,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.495L4.045,-13.495L5.972,-3.968L6.01,-3.968L7.957,-13.495L11.983,-13.495L11.983,0L9.488,0L9.488,-10.773L9.45,-10.773L7.05,0L4.933,0L2.533,-10.773L2.496,-10.773L2.496,0L0,0L0,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,273.659,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-17.01L2.608,-17.01L0.756,-14.289L-1.02,-14.289L0,-17.01ZM-1.04,-13.495L1.681,-13.495L1.681,0L-1.04,0L-1.04,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,279.838,211.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.487L1.209,9.487C1.677,9.487 2.057,9.406 2.353,9.241C2.65,9.078 2.883,8.807 3.052,8.43C3.222,8.05 3.336,7.554 3.393,6.938C3.449,6.32 3.478,5.549 3.478,4.63C3.478,3.862 3.452,3.191 3.401,2.618C3.351,2.046 3.247,1.563 3.091,1.173C2.933,0.782 2.701,0.488 2.39,0.293C2.082,0.098 1.67,-0 1.152,-0L0,-0L0,9.487ZM-2.721,-2.004L1.739,-2.004C2.684,-2.004 3.446,-1.85 4.027,-1.54C4.606,-1.232 5.055,-0.79 5.377,-0.218C5.698,0.355 5.916,1.046 6.029,1.852C6.143,2.659 6.199,3.559 6.199,4.554C6.199,5.752 6.126,6.785 5.981,7.653C5.836,8.524 5.587,9.241 5.235,9.809C4.883,10.376 4.411,10.798 3.818,11.075C3.226,11.353 2.476,11.491 1.569,11.491L-2.721,11.491L-2.721,-2.004Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,122.168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.588,
    y: 86.974,
    width: 2.722,
    height: 13.495,
    style: {
      fill: "rgb(89,111,139)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,294.94,214.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.329L2.646,3.329L1.342,-2.738L1.305,-2.738L0,3.329ZM-0.358,-5.083L3.006,-5.083L6.576,8.412L3.742,8.412L3.118,5.559L-0.472,5.559L-1.097,8.412L-3.932,8.412L-0.358,-5.083Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,308.681,215.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.003C0,0.904 0.021,1.677 0.064,2.313C0.108,2.951 0.198,3.465 0.329,3.862C0.462,4.259 0.651,4.551 0.896,4.733C1.143,4.915 1.466,5.005 1.87,5.005C2.273,5.005 2.597,4.915 2.843,4.733C3.089,4.551 3.278,4.259 3.411,3.862C3.543,3.465 3.631,2.951 3.675,2.313C3.719,1.677 3.741,0.904 3.741,-0.003C3.741,-0.909 3.719,-1.678 3.675,-2.308C3.631,-2.939 3.543,-3.453 3.411,-3.857C3.278,-4.26 3.089,-4.554 2.843,-4.736C2.597,-4.918 2.273,-5.011 1.87,-5.011C1.466,-5.011 1.143,-4.918 0.896,-4.736C0.651,-4.554 0.462,-4.26 0.329,-3.857C0.198,-3.453 0.108,-2.939 0.064,-2.308C0.021,-1.678 0,-0.909 0,-0.003M-2.723,-0.003C-2.723,-1.024 -2.676,-1.965 -2.58,-2.827C-2.486,-3.691 -2.279,-4.432 -1.956,-5.05C-1.636,-5.667 -1.173,-6.148 -0.568,-6.495C0.037,-6.842 0.85,-7.014 1.87,-7.014C2.892,-7.014 3.705,-6.842 4.309,-6.495C4.914,-6.148 5.375,-5.667 5.698,-5.05C6.019,-4.432 6.227,-3.691 6.321,-2.827C6.416,-1.965 6.463,-1.024 6.463,-0.003C6.463,1.018 6.416,1.96 6.321,2.824C6.227,3.685 6.019,4.427 5.698,5.044C5.375,5.661 4.914,6.143 4.309,6.489C3.705,6.837 2.892,7.011 1.87,7.011C0.85,7.011 0.037,6.837 -0.568,6.489C-1.173,6.143 -1.636,5.661 -1.956,5.044C-2.279,4.427 -2.486,3.685 -2.58,2.824C-2.676,1.96 -2.723,1.018 -2.723,-0.003",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,316.373,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.495L7.54,-13.495L7.54,-11.265L2.721,-11.265L2.721,-8.088L7.257,-8.088L7.257,-5.86L2.721,-5.86L2.721,0L0,0L0,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,122.168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.878,
    y: 86.974,
    width: 2.723,
    height: 13.495,
    style: {
      fill: "rgb(89,111,139)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,335.007,218.083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.386C0,-5.368 -0.116,-6.085 -0.349,-6.531C-0.582,-6.979 -1.008,-7.202 -1.624,-7.202C-1.965,-7.202 -2.247,-7.11 -2.465,-6.928C-2.688,-6.745 -2.86,-6.449 -2.986,-6.039C-3.112,-5.63 -3.2,-5.094 -3.251,-4.433C-3.301,-3.773 -3.325,-2.962 -3.325,-2.005C-3.325,-0.985 -3.291,-0.159 -3.223,0.471C-3.152,1.102 -3.045,1.59 -2.9,1.937C-2.757,2.282 -2.573,2.515 -2.352,2.635C-2.132,2.756 -1.877,2.813 -1.588,2.813C-1.348,2.813 -1.125,2.773 -0.917,2.691C-0.708,2.61 -0.528,2.445 -0.377,2.2C-0.227,1.956 -0.106,1.609 -0.019,1.16C0.07,0.714 0.114,0.125 0.114,-0.605L2.835,-0.605C2.835,0.125 2.778,0.817 2.666,1.473C2.552,2.13 2.34,2.705 2.033,3.202C1.724,3.7 1.289,4.094 0.727,4.384C0.167,4.673 -0.561,4.819 -1.455,4.819C-2.477,4.819 -3.288,4.645 -3.894,4.298C-4.498,3.952 -4.961,3.469 -5.282,2.852C-5.604,2.235 -5.81,1.494 -5.905,0.633C-6.001,-0.232 -6.049,-1.173 -6.049,-2.195C-6.049,-3.215 -6.001,-4.157 -5.905,-5.019C-5.81,-5.883 -5.604,-6.623 -5.282,-7.241C-4.961,-7.859 -4.498,-8.339 -3.894,-8.687C-3.288,-9.033 -2.477,-9.205 -1.455,-9.205C-0.484,-9.205 0.28,-9.049 0.842,-8.734C1.403,-8.418 1.82,-8.017 2.098,-7.532C2.377,-7.048 2.549,-6.525 2.618,-5.964C2.688,-5.403 2.723,-4.877 2.723,-4.386L0,-4.386Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,122.168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.148,
    y: 86.974,
    width: 2.721,
    height: 13.495,
    style: {
      fill: "rgb(89,111,139)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,346.497,214.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.329L2.646,3.329L1.344,-2.738L1.306,-2.738L0,3.329ZM-0.358,-5.083L3.007,-5.083L6.578,8.412L3.744,8.412L3.118,5.559L-0.472,5.559L-1.095,8.412L-3.931,8.412L-0.358,-5.083Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,353.645,209.142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.495L0,0L2.722,0L2.722,11.264L7.54,11.264L7.54,13.495L0,13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,369.028,211.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.487L1.209,9.487C1.676,9.487 2.058,9.406 2.353,9.241C2.649,9.078 2.883,8.807 3.052,8.43C3.223,8.05 3.336,7.554 3.394,6.938C3.449,6.32 3.479,5.549 3.479,4.63C3.479,3.862 3.452,3.191 3.401,2.618C3.352,2.046 3.247,1.563 3.091,1.173C2.933,0.782 2.7,0.488 2.39,0.293C2.081,0.098 1.67,-0 1.152,-0L0,-0L0,9.487ZM-2.722,-2.004L1.738,-2.004C2.685,-2.004 3.445,-1.85 4.026,-1.54C4.605,-1.232 5.055,-0.79 5.377,-0.218C5.698,0.355 5.916,1.046 6.028,1.852C6.143,2.659 6.199,3.559 6.199,4.554C6.199,5.752 6.127,6.785 5.981,7.653C5.836,8.524 5.587,9.241 5.235,9.809C4.883,10.376 4.411,10.798 3.818,11.075C3.226,11.353 2.476,11.491 1.569,11.491L-2.722,11.491L-2.722,-2.004Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.083,215.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.003C0,0.904 0.021,1.677 0.065,2.313C0.109,2.951 0.199,3.465 0.331,3.862C0.463,4.259 0.651,4.551 0.897,4.733C1.143,4.915 1.467,5.005 1.87,5.005C2.274,5.005 2.599,4.915 2.844,4.733C3.09,4.551 3.278,4.259 3.412,3.862C3.544,3.465 3.633,2.951 3.676,2.313C3.72,1.677 3.743,0.904 3.743,-0.003C3.743,-0.909 3.72,-1.678 3.676,-2.308C3.633,-2.939 3.544,-3.453 3.412,-3.857C3.278,-4.26 3.09,-4.554 2.844,-4.736C2.599,-4.918 2.274,-5.011 1.87,-5.011C1.467,-5.011 1.143,-4.918 0.897,-4.736C0.651,-4.554 0.463,-4.26 0.331,-3.857C0.199,-3.453 0.109,-2.939 0.065,-2.308C0.021,-1.678 0,-0.909 0,-0.003M-2.724,-0.003C-2.724,-1.024 -2.676,-1.965 -2.579,-2.827C-2.484,-3.691 -2.277,-4.432 -1.956,-5.05C-1.636,-5.667 -1.171,-6.148 -0.567,-6.495C0.038,-6.842 0.85,-7.014 1.87,-7.014C2.891,-7.014 3.705,-6.842 4.309,-6.495C4.914,-6.148 5.377,-5.667 5.699,-5.05C6.02,-4.432 6.229,-3.691 6.322,-2.827C6.417,-1.965 6.464,-1.024 6.464,-0.003C6.464,1.018 6.417,1.96 6.322,2.824C6.229,3.685 6.02,4.427 5.699,5.044C5.377,5.661 4.914,6.143 4.309,6.489C3.705,6.837 2.891,7.011 1.87,7.011C0.85,7.011 0.038,6.837 -0.567,6.489C-1.171,6.143 -1.636,5.661 -1.956,5.044C-2.277,4.427 -2.484,3.685 -2.579,2.824C-2.676,1.96 -2.724,1.018 -2.724,-0.003",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,390.934,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.495L7.541,-13.495L7.541,-11.265L2.722,-11.265L2.722,-8.088L7.258,-8.088L7.258,-5.86L2.722,-5.86L2.722,0L0,0L0,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,401.744,215.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.003C0,0.904 0.021,1.677 0.065,2.313C0.109,2.951 0.199,3.465 0.33,3.862C0.462,4.259 0.65,4.551 0.897,4.733C1.144,4.915 1.467,5.005 1.87,5.005C2.274,5.005 2.599,4.915 2.844,4.733C3.089,4.551 3.277,4.259 3.412,3.862C3.543,3.465 3.631,2.951 3.675,2.313C3.719,1.677 3.742,0.904 3.742,-0.003C3.742,-0.909 3.719,-1.678 3.675,-2.308C3.631,-2.939 3.543,-3.453 3.412,-3.857C3.277,-4.26 3.089,-4.554 2.844,-4.736C2.599,-4.918 2.274,-5.011 1.87,-5.011C1.467,-5.011 1.144,-4.918 0.897,-4.736C0.65,-4.554 0.462,-4.26 0.33,-3.857C0.199,-3.453 0.109,-2.939 0.065,-2.308C0.021,-1.678 0,-0.909 0,-0.003M-2.723,-0.003C-2.723,-1.024 -2.676,-1.965 -2.579,-2.827C-2.484,-3.691 -2.277,-4.432 -1.956,-5.05C-1.635,-5.667 -1.171,-6.148 -0.567,-6.495C0.037,-6.842 0.851,-7.014 1.87,-7.014C2.891,-7.014 3.705,-6.842 4.309,-6.495C4.913,-6.148 5.377,-5.667 5.698,-5.05C6.02,-4.432 6.227,-3.691 6.321,-2.827C6.416,-1.965 6.463,-1.024 6.463,-0.003C6.463,1.018 6.416,1.96 6.321,2.824C6.227,3.685 6.02,4.427 5.698,5.044C5.377,5.661 4.913,6.143 4.309,6.489C3.705,6.837 2.891,7.011 1.87,7.011C0.851,7.011 0.037,6.837 -0.567,6.489C-1.171,6.143 -1.635,5.661 -1.956,5.044C-2.277,4.427 -2.484,3.685 -2.579,2.824C-2.676,1.96 -2.723,1.018 -2.723,-0.003",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,412.158,216.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.699L1.134,-1.699C1.788,-1.699 2.293,-1.853 2.646,-2.162C2.998,-2.471 3.175,-2.99 3.175,-3.721C3.175,-4.97 2.544,-5.594 1.283,-5.594L0,-5.594L0,-1.699ZM-2.723,-7.597L2.307,-7.597C3.438,-7.597 4.321,-7.309 4.95,-6.737C5.58,-6.163 5.896,-5.292 5.896,-4.118C5.896,-3.211 5.714,-2.471 5.348,-1.899C4.981,-1.326 4.415,-0.957 3.647,-0.794L3.647,-0.756C4.111,-0.691 4.485,-0.575 4.763,-0.406C5.039,-0.234 5.253,0.01 5.405,0.332C5.557,0.654 5.66,1.059 5.718,1.55C5.772,2.041 5.809,2.646 5.82,3.364C5.833,4.083 5.874,4.632 5.943,5.009C6.013,5.387 6.173,5.647 6.426,5.785L6.426,5.898L3.444,5.898C3.303,5.708 3.215,5.491 3.175,5.245C3.138,5.001 3.112,4.745 3.099,4.48L3.023,1.891C2.999,1.362 2.869,0.946 2.631,0.645C2.396,0.341 1.996,0.19 1.437,0.19L0,0.19L0,5.898L-2.723,5.898L-2.723,-7.597Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,422.704,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.495L3.288,-4.254L3.325,-4.254L3.325,-13.495L5.821,-13.495L5.821,0L2.72,0L-0.604,-9.45L-0.644,-9.45L-0.644,0L-3.138,0L-3.138,-13.495L0,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,437.577,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.495L0,-11.265L-4.819,-11.265L-4.819,-8.088L-0.283,-8.088L-0.283,-5.86L-4.819,-5.86L-4.819,-2.231L0.189,-2.231L0.189,0L-7.54,0L-7.54,-13.495L0,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.515,218.083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.386C0,-5.368 -0.116,-6.085 -0.35,-6.531C-0.583,-6.979 -1.008,-7.202 -1.625,-7.202C-1.965,-7.202 -2.246,-7.11 -2.466,-6.928C-2.688,-6.745 -2.86,-6.449 -2.985,-6.039C-3.112,-5.63 -3.2,-5.094 -3.25,-4.433C-3.302,-3.773 -3.326,-2.962 -3.326,-2.005C-3.326,-0.985 -3.292,-0.159 -3.223,0.471C-3.153,1.102 -3.046,1.59 -2.9,1.937C-2.756,2.282 -2.573,2.515 -2.353,2.635C-2.133,2.756 -1.877,2.813 -1.587,2.813C-1.349,2.813 -1.126,2.773 -0.916,2.691C-0.708,2.61 -0.529,2.445 -0.378,2.2C-0.227,1.956 -0.105,1.609 -0.018,1.16C0.069,0.714 0.113,0.125 0.113,-0.605L2.835,-0.605C2.835,0.125 2.778,0.817 2.665,1.473C2.552,2.13 2.341,2.705 2.033,3.202C1.724,3.7 1.288,4.094 0.728,4.384C0.166,4.673 -0.561,4.819 -1.456,4.819C-2.476,4.819 -3.288,4.645 -3.893,4.298C-4.497,3.952 -4.961,3.469 -5.281,2.852C-5.604,2.235 -5.811,1.494 -5.905,0.633C-6.001,-0.232 -6.049,-1.173 -6.049,-2.195C-6.049,-3.215 -6.001,-4.157 -5.905,-5.019C-5.811,-5.883 -5.604,-6.623 -5.281,-7.241C-4.961,-7.859 -4.497,-8.339 -3.893,-8.687C-3.288,-9.033 -2.476,-9.205 -1.456,-9.205C-0.485,-9.205 0.281,-9.049 0.842,-8.734C1.402,-8.418 1.821,-8.017 2.098,-7.532C2.376,-7.048 2.549,-6.525 2.618,-5.964C2.687,-5.403 2.723,-4.877 2.723,-4.386L0,-4.386Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,456.063,222.637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-13.495L0,-11.265L-4.819,-11.265L-4.819,-8.088L-0.283,-8.088L-0.283,-5.86L-4.819,-5.86L-4.819,-2.231L0.188,-2.231L0.188,0L-7.541,0L-7.541,-13.495L0,-13.495Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,460.087,211.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.487L1.21,9.487C1.676,9.487 2.059,9.406 2.354,9.241C2.649,9.078 2.883,8.807 3.052,8.43C3.223,8.05 3.337,7.554 3.395,6.938C3.448,6.32 3.479,5.549 3.479,4.63C3.479,3.862 3.452,3.191 3.401,2.618C3.351,2.046 3.247,1.563 3.091,1.173C2.934,0.782 2.701,0.488 2.392,0.293C2.081,0.098 1.67,-0 1.153,-0L0,-0L0,9.487ZM-2.722,-2.004L1.738,-2.004C2.685,-2.004 3.446,-1.85 4.026,-1.54C4.605,-1.232 5.055,-0.79 5.378,-0.218C5.698,0.355 5.916,1.046 6.029,1.852C6.143,2.659 6.199,3.559 6.199,4.554C6.199,5.752 6.126,6.785 5.981,7.653C5.837,8.524 5.588,9.241 5.236,9.809C4.882,10.376 4.41,10.798 3.819,11.075C3.226,11.353 2.476,11.491 1.568,11.491L-2.722,11.491L-2.722,-2.004Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,470.142,215.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.003C0,0.904 0.022,1.677 0.066,2.313C0.11,2.951 0.199,3.465 0.331,3.862C0.463,4.259 0.651,4.551 0.897,4.733C1.143,4.915 1.467,5.005 1.871,5.005C2.274,5.005 2.599,4.915 2.844,4.733C3.091,4.551 3.279,4.259 3.412,3.862C3.544,3.465 3.632,2.951 3.676,2.313C3.72,1.677 3.742,0.904 3.742,-0.003C3.742,-0.909 3.72,-1.678 3.676,-2.308C3.632,-2.939 3.544,-3.453 3.412,-3.857C3.279,-4.26 3.091,-4.554 2.844,-4.736C2.599,-4.918 2.274,-5.011 1.871,-5.011C1.467,-5.011 1.143,-4.918 0.897,-4.736C0.651,-4.554 0.463,-4.26 0.331,-3.857C0.199,-3.453 0.11,-2.939 0.066,-2.308C0.022,-1.678 0,-0.909 0,-0.003M-2.722,-0.003C-2.722,-1.024 -2.674,-1.965 -2.579,-2.827C-2.485,-3.691 -2.278,-4.432 -1.956,-5.05C-1.635,-5.667 -1.171,-6.148 -0.567,-6.495C0.038,-6.842 0.851,-7.014 1.871,-7.014C2.892,-7.014 3.705,-6.842 4.309,-6.495C4.914,-6.148 5.377,-5.667 5.699,-5.05C6.021,-4.432 6.228,-3.691 6.322,-2.827C6.417,-1.965 6.464,-1.024 6.464,-0.003C6.464,1.018 6.417,1.96 6.322,2.824C6.228,3.685 6.021,4.427 5.699,5.044C5.377,5.661 4.914,6.143 4.309,6.489C3.705,6.837 2.892,7.011 1.871,7.011C0.851,7.011 0.038,6.837 -0.567,6.489C-1.171,6.143 -1.635,5.661 -1.956,5.044C-2.278,4.427 -2.485,3.685 -2.579,2.824C-2.674,1.96 -2.722,1.018 -2.722,-0.003",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,480.558,216.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.699L1.134,-1.699C1.788,-1.699 2.293,-1.853 2.646,-2.162C2.998,-2.471 3.175,-2.99 3.175,-3.721C3.175,-4.97 2.544,-5.594 1.285,-5.594L0,-5.594L0,-1.699ZM-2.722,-7.597L2.307,-7.597C3.438,-7.597 4.321,-7.309 4.95,-6.737C5.58,-6.163 5.896,-5.292 5.896,-4.118C5.896,-3.211 5.714,-2.471 5.348,-1.899C4.981,-1.326 4.416,-0.957 3.646,-0.794L3.646,-0.756C4.112,-0.691 4.485,-0.575 4.762,-0.406C5.038,-0.234 5.253,0.01 5.405,0.332C5.557,0.654 5.661,1.059 5.717,1.55C5.773,2.041 5.809,2.646 5.82,3.364C5.833,4.083 5.874,4.632 5.943,5.009C6.013,5.387 6.174,5.647 6.426,5.785L6.426,5.898L3.443,5.898C3.303,5.708 3.214,5.491 3.175,5.245C3.138,5.001 3.111,4.745 3.099,4.48L3.023,1.891C2.999,1.362 2.869,0.946 2.632,0.645C2.396,0.341 1.997,0.19 1.437,0.19L0,0.19L0,5.898L-2.722,5.898L-2.722,-7.597Z",
    style: {
      fill: "rgb(89,111,139)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMofCor);
export default __webpack_public_path__ + "static/media/LogoMof_Cor.7a3f9acedfa027d389f56f08e049e0f3.svg";
export { ForwardRef as ReactComponent };